import {fieldValue, isAnyEqualToFirst, setFieldValue} from "../common/NamaCommon";
import * as FieldType from '../constants/FieldType'
import * as ft from '../constants/FieldType'
import {refCodeOrNameEditor, referenceCodeTemplate, referenceColumnEditor, referenceNameTemplate, referenceTemplate} from "./GridCell_Reference";
import {
    getAllowedValuesFor,
    getFieldDisplayMask,
    getFieldStyle,
    isFieldValuesRestricted,
    isRichTextField,
    isTextToEmailLinkField,
    isTextToLinkField,
    isTextToPhoneNumberLinkField
} from "../login/ClientCache";
import {booleanColumnEditor, booleanTemplate} from "./GridCell_Boolean";
import {dateColumnEditor, dateTemplate} from "./GridCell_Date";
import {dateTimeColumnEditor, dateTimeTemplate} from "./GridCell_DateTime";
import {timeColumnEditor, timeTemplate} from "./GridCell_Time";
import {comboColumnEditor, comboTemplate} from "./GridCell_Combo";
import {fieldHasSuggestionProvider} from "../widgets/FieldWidgetCreator";
import {autoCompleteColumnEditor, fieldIdTemplate} from "./GridCell_AutoComplete";
import {findFieldMetadata} from "../common/Metadata";
import {calcByLanguage} from "../views/treeView/TreeModelProvider";
import {modelId} from "./NamaGridWidget";
import {attachColumnEditor, attachTemplate} from "./GridCell_Attachment";
import {decimalColumnEditor, integerColumnEditor} from "./GridCell_Numeric";
import {passwordColumnEditor, passwordTemplate} from "./GridCell_Password";
import {NamaGridLineEditor} from "./NamaGridLineEditor";
import {RichTextEditorWidget} from "../widgets/RichTextEditorWidget";
import {LongTextWidget} from "../widgets/LongTextWidget";
import {TextFieldWidget} from "../widgets/TextFieldWidget";
import {fetchAndApplyStyle} from "../widgets/BaseWidget";
import {colorColumnEditor, colorTemplate} from "./GridCell_Color";

function genericDataItemSetter(trimmedId, grid, dataItem, value) {
    setFieldValue(dataItem, trimmedId, value);
    dataItem[modelId(grid.id + "." + trimmedId)] = value;
}

function numberDataItemSetter(trimmedId, grid, dataItem, value) {
    setFieldValue(dataItem, trimmedId, value);
    dataItem[modelId(grid.id + "." + trimmedId + ".unformatted")] = value;
}

function referenceCodeAndNameSetter(trimmedId, grid, dataItem, value) {
    let refNameModelId = modelId(grid.id + "." + trimmedId + ".name");
    let refCodeModelId = modelId(grid.id + "." + trimmedId + ".code");
    let name = value ? calcByLanguage(value.name1, value.name2) : "";
    let code = value ? value.code : "";
    dataItem[refNameModelId] = name;
    dataItem[refCodeModelId] = code;
}

function referenceSetter(trimmedId, grid, dataItem, value) {
    setFieldValue(dataItem, trimmedId, value);
    if (grid.settingValueFromNest)//No need to call setters of code and name fields while working whith FieldValueSetter
        // , this caused a lot of delay because the grid refreshed many many times and it affected the speed of setting fields a lot
        return;
    if (!dataItem.callFromRefEntitySetter) {
        dataItem.callFromRefSetter = true;
        let entityType = value ? value.entityType : "";
        let code = value ? value.code : "";
        let altCode = value ? value.altCode : "";
        let name1 = value ? value.name1 : "";
        let name2 = value ? value.name2 : "";
        let id = value ? value.id : "";
        dataItem[modelId(grid.id + "." + trimmedId + ".entityType")] = entityType;
        dataItem[modelId(grid.id + "." + trimmedId + ".code")] = code;
        dataItem[modelId(grid.id + "." + trimmedId + ".altCode")] = altCode;
        dataItem[modelId(grid.id + "." + trimmedId + ".name")] = calcByLanguage(name1, name2);
        dataItem[modelId(grid.id + "." + trimmedId + ".name1")] = name1;
        dataItem[modelId(grid.id + "." + trimmedId + ".name2")] = name2;
        if (id) {
            dataItem[modelId(grid.id + "." + trimmedId + ".dashedId")] = id;
            dataItem[modelId(grid.id + "." + trimmedId + ".nonDashedId")] = id.replaceAll("-", "");
            dataItem[modelId(grid.id + "." + trimmedId + ".normalId")] = "0x" + id;
        }
        dataItem[modelId(grid.id + "." + trimmedId)] = code;
        delete dataItem.callFromRefSetter;
    }
}

function referenceEntityTypeSetter(trimmedId, grid, dataItem, value) {
    let refFieldId = trimmedId.substring(0, trimmedId.length - ".entityType".length);
    let refModelId = modelId(grid.id + "." + refFieldId);
    let ref = dataItem[refFieldId];
    ref = ref || {};
    if (ref.entityType !== value) {
        ref = {entityType: value};
        if (!dataItem.callFromRefSetter && !grid.settingValueFromNest) {
            dataItem.callFromRefEntitySetter = true;
            dataItem[refModelId] = ref;
            dataItem[refModelId + "$entityType"] = value;
            delete dataItem.callFromRefEntitySetter;
            setFieldValue(dataItem, refFieldId, ref);
        }
    }
    setFieldValue(dataItem, trimmedId, value);
}


function fetchMetaDataForColId(trimmedFieldId, grid) {
    let columnMetadata = findFieldMetadata(grid.id + "." + trimmedFieldId, grid.metaData);
    if (columnMetadata)
        return columnMetadata;
    let refColId = trimmedFieldId;
    if (trimmedFieldId.endsWith(".name") || trimmedFieldId.endsWith(".code"))
        refColId = trimmedFieldId.substring(0, trimmedFieldId.length - 5);
    if (trimmedFieldId.endsWith(".entityType"))
        refColId = trimmedFieldId.substring(0, trimmedFieldId.length - 11);
    return findFieldMetadata(grid.id + "." + refColId, grid.metaData);
}

export function dataItemSetterCallback(trimmedFieldId, grid, dataItem, value) {
    let columnMetadata = fetchMetaDataForColId(trimmedFieldId, grid);
    if (!columnMetadata)
        return genericDataItemSetter(trimmedFieldId, grid, dataItem, value);
    let isNumber = columnMetadata.fieldType === FieldType.Decimal || columnMetadata.fieldType === FieldType.Integer || columnMetadata.fieldType === FieldType.Long;
    if (isNumber)
        return numberDataItemSetter(trimmedFieldId, grid, dataItem, value);
    if (columnMetadata.fieldType !== FieldType.Reference && columnMetadata.fieldType !== FieldType.Genericreference)
        return genericDataItemSetter(trimmedFieldId, grid, dataItem, value);
    else {
        if (trimmedFieldId.endsWith(".entityType"))
            return referenceEntityTypeSetter(trimmedFieldId, grid, dataItem, value);
        if (trimmedFieldId.endsWith(".name") || trimmedFieldId.endsWith(".code"))
            return referenceCodeAndNameSetter(trimmedFieldId, grid, dataItem, value);
        return referenceSetter(trimmedFieldId, grid, dataItem, value);
    }
    return genericDataItemSetter(trimmedFieldId, grid, dataItem, value);
}

function defaultEditor(fieldMetadata, trimmedFieldId, grid) {
    return (container, options) => {
        let widget = new TextFieldWidget({owner: grid, fieldMetadata, cellOptions: options});
        widget.inputName = options.field;
        grid.afterAddingToGridAction(widget, options, trimmedFieldId, container);
    }
}

/**
 *
 * @param {ExtendedFieldMetaData} fieldMetadata
 * @param {string} trimmedFieldId
 * @param {NamaGridWidget} grid
 */
export function columnEditor(fieldMetadata, trimmedFieldId, grid, colId) {
    let ownerId = grid.entityType;
    if (isAnyEqualToFirst(fieldMetadata.fieldType, FieldType.BigText, FieldType.Text, FieldType.Color, FieldType.PhoneNumber, FieldType.Decimal
        , FieldType.Integer, FieldType.Long, FieldType.Password, FieldType.Link, FieldType.Email) && isFieldValuesRestricted(ownerId, fieldMetadata.fieldId))
        fieldMetadata.allowedValues = getAllowedValuesFor(ownerId, fieldMetadata.fieldId);
    if (grid.refCodeOrNameCol(colId))
        return refCodeOrNameEditor(trimmedFieldId);
    if (isPassword(ownerId, fieldMetadata))
        return passwordColumnEditor(fieldMetadata, trimmedFieldId, grid);
    let isAutoComplete = fieldHasSuggestionProvider(fieldMetadata, ownerId) && fieldMetadata.fieldType !== FieldType.Reference && fieldMetadata.fieldType !== FieldType.Genericreference;
    if (isAutoComplete) {
        if (fieldMetadata.fieldType === FieldType.BigText)
            return bigTextColumnEditor(fieldMetadata, trimmedFieldId, grid);
        return autoCompleteColumnEditor(fieldMetadata, trimmedFieldId, grid);
    }
    if (fieldMetadata.fieldType === FieldType.Reference || fieldMetadata.fieldType === FieldType.Genericreference)
        return referenceColumnEditor(fieldMetadata, trimmedFieldId, grid);
    if (fieldMetadata.fieldType === FieldType.BigText)
        return bigTextColumnEditor(fieldMetadata, trimmedFieldId, grid);
    if (fieldMetadata.fieldType === FieldType.Boolean)
        return booleanColumnEditor(fieldMetadata, trimmedFieldId, grid);
    if (fieldMetadata.fieldType === FieldType.Color)
        return colorColumnEditor(fieldMetadata, trimmedFieldId, grid);
    if (fieldMetadata.fieldType === FieldType.Date)
        return dateColumnEditor(fieldMetadata, trimmedFieldId, grid);
    if (fieldMetadata.fieldType === FieldType.Time)
        return timeColumnEditor(fieldMetadata, trimmedFieldId, grid);
    if (fieldMetadata.fieldType === FieldType.DateAndTime)
        return dateTimeColumnEditor(fieldMetadata, trimmedFieldId, grid);
    if (isAnyEqualToFirst(fieldMetadata.fieldType, FieldType.Enum, FieldType.EntityType, FieldType.FeatureID) || (fieldMetadata.allowedValues && fieldMetadata.allowedValues.length)) {
        return comboColumnEditor(fieldMetadata, trimmedFieldId, grid);
    }
    if (fieldMetadata.fieldType === FieldType.Binary)
        return attachColumnEditor(fieldMetadata, trimmedFieldId, grid);
    if (fieldMetadata.fieldType === FieldType.Decimal || fieldMetadata.fieldType === FieldType.Long)
        return decimalColumnEditor(fieldMetadata, trimmedFieldId, grid);
    if (fieldMetadata.fieldType === FieldType.Integer)
        return integerColumnEditor(fieldMetadata, trimmedFieldId, grid);
    return defaultEditor(fieldMetadata, trimmedFieldId, grid);
}

function gridLineEditorBigText(grid, fieldMetadata, container, options, trimmedFieldId) {
    let widget = new LongTextWidget({owner: grid, fieldMetadata, cellOptions: options});
    if (isRichTextField(grid.entityType, fieldMetadata.fieldId))
        widget = new RichTextEditorWidget({owner: grid, fieldMetadata, cellOptions: options});
    widget.inputName = options.field;
    grid.afterAddingToGridAction(widget, options, trimmedFieldId, container);
}

function bigTextColumnEditor(fieldMetadata, trimmedFieldId, grid) {
    return (container, options) => {
        if (container instanceof NamaGridLineEditor) {
            gridLineEditorBigText(grid, fieldMetadata, container, options, trimmedFieldId);
            return;
        }

        if (isRichTextField(grid.entityType, fieldMetadata.fieldId))
            $(`<div class="w-100" name='${options.field}'</div>`).appendTo(container).kendoEditor({
                change: function () {
                    grid.onDataChanged(fieldMetadata.fieldId, this.value(), options);
                }
            });
        else {
            let textArea = $(`<textarea class="w-100" rows = '4' name='${options.field}'></textarea>`);
            textArea.change(function () {
                grid.onDataChanged(fieldMetadata.fieldId, textArea.val(), options);
            });
            textArea.appendTo(container);
            fetchAndApplyStyle(grid.entityType, grid.id + "." + trimmedFieldId, textArea);
        }
    }
}

function bigTextColumnTemplate(fieldMetadata, trimmedFieldId, grid) {
    return (dataItem) => {
        if (isRichTextField(grid.entityType, fieldMetadata.fieldId))
            return undefined;
        else {
            let val = fieldValue(dataItem, trimmedFieldId);
            return val ? `<span title='${extractTextFromHTML(val)}'>${val}</span>` : "";
        }
    }
}

export function extractTextFromHTML(s) {
    if (!s || !s.includes)
        return s;
    if (!(s.includes("<") && s.includes(">")))
        return s;
    let span = document.createElement('span');
    if (s.includes("<style>") && s.includes("</style>")) {
        if (s.endsWith("</style>"))
            s = s.substring(0, s.indexOf("<style>"))
        else
            s = s.substring(0, s.indexOf("<style>")) + s.substring(s.indexOf("</style>"))
    }
    span.innerHTML = s;
    let innerContent = span.textContent || span.innerText;
    innerContent = innerContent.replace(new RegExp("\t", 'g'), " ");
    innerContent = innerContent.replace(new RegExp(/\n +/g), "\n");
    innerContent = innerContent.replace(new RegExp(/\n+/g), "\n");
    return innerContent;
};

/**
 *
 * @param {ExtendedFieldMetaData} fieldMetadata
 */
export function columnTemplate(fieldMetadata, trimmedFieldId, grid, colId) {
    if (grid.refCodeOrNameCol(colId)) {
        if (colId.endsWith(".code"))
            return referenceCodeTemplate(trimmedFieldId)
        if (colId.endsWith(".name"))
            return referenceNameTemplate(trimmedFieldId)
    }
    if (fieldMetadata.fieldType === FieldType.FieldID)
        return fieldIdTemplate(fieldMetadata.fieldId, trimmedFieldId);
    if (fieldMetadata.fieldType === FieldType.Reference || fieldMetadata.fieldType === FieldType.Genericreference)
        return referenceTemplate(trimmedFieldId, fieldMetadata)
    if (fieldMetadata.fieldType == FieldType.BigText)
        return bigTextColumnTemplate(fieldMetadata, trimmedFieldId, grid);
    if (fieldMetadata.fieldType == FieldType.Boolean)
        return booleanTemplate(fieldMetadata.fieldId, trimmedFieldId);
    if (fieldMetadata.fieldType == FieldType.Color)
        return colorTemplate(fieldMetadata.fieldId, trimmedFieldId);
    if (fieldMetadata.fieldType == FieldType.DateAndTime)
        return dateTimeTemplate(fieldMetadata.fieldId, trimmedFieldId);
    if (fieldMetadata.fieldType == FieldType.Date)
        return dateTemplate(fieldMetadata.fieldId, trimmedFieldId);
    if (fieldMetadata.fieldType == FieldType.Time)
        return timeTemplate(fieldMetadata.fieldId, trimmedFieldId);
    if (fieldMetadata.fieldType == FieldType.Enum || fieldMetadata.fieldType === FieldType.EntityType)
        return comboTemplate(fieldMetadata.fieldId, trimmedFieldId);
    if (fieldMetadata.fieldType == FieldType.Binary)
        return attachTemplate(fieldMetadata.fieldId, trimmedFieldId);
    if (isPassword(grid.entityType, fieldMetadata))
        return passwordTemplate(fieldMetadata.fieldId, trimmedFieldId);
    let textToLinkField = fieldMetadata.fieldType === ft.Link || isTextToLinkField(fieldMetadata.fieldId, grid.entityType);
    if (textToLinkField)
        return linkTemplate(grid.entityType, trimmedFieldId);
    if (isTextToPhoneNumberLinkField(fieldMetadata.fieldId, grid.entityType) || fieldMetadata.fieldType == ft.PhoneNumber)
        return linkTemplate(grid.entityType, trimmedFieldId, "tel:");
    if (isTextToEmailLinkField(fieldMetadata.fieldId, grid.entityType) || fieldMetadata.fieldType == ft.Email)
        return linkTemplate(grid.entityType, trimmedFieldId, "mailto");
    return textTemplate(grid.entityType, trimmedFieldId, fieldMetadata.fieldId);
}

function textTemplate(entityType, trimmedFieldId, fieldId) {
    return (dataItem) => {
        let value = fieldValue(dataItem, trimmedFieldId);
        if (!value)
            return "";
        let format = getFieldDisplayMask(entityType, fieldId);
        if (format)
            return `<span title='${kendo.toString(value, format)}'>${kendo.toString(value, format)}</span>`;
        return `<span title='${extractTextFromHTML(value)}'>${value}</span>`;
    }
}

function linkTemplate(entityType, trimmedFieldId, scheme) {
    return (dataItem) => {
        let value = fieldValue(dataItem, trimmedFieldId);
        if (!value)
            return "";
        return `<a title= '${value}' href="${(scheme ? scheme : "") + value}" target="_blank">${value}</a>`;
    }
}

export function isPassword(entityType, fieldMetadata) {
    if (fieldMetadata.fieldType === FieldType.Password)
        return true;
    let fieldStyle = getFieldStyle(entityType, fieldMetadata.fieldId);
    if (fieldStyle && fieldStyle.showAsPassword)
        return true;
    return false;
}